export { default, ensureViewlessImageComponent } from "./ViewlessImageConfig";
